import React from 'react';
import { NavLink } from 'react-router-dom';

import './PageNavigationLink.scss';

const PageNavigationLink = props => {
  const { path, label, disabled, onClick } = props;

  let linkClasses = ['parkchirp--page-navigation-link'];
  if (disabled) {
    linkClasses.push('disabled');
  }

  const handleClick = event => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    if(onClick){
      onClick()
    };
  }

  return (
    <li>
      <NavLink
        to={path}
        className={linkClasses.join(' ')}
        onClick={handleClick}
      >{label}</NavLink>
    </li>
  );
}

export default PageNavigationLink;
